"use client";

import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import dynamic from "next/dynamic";

// Fuse.js + index (≈70 Ko) chargés uniquement à la première ouverture
const SearchDialog = dynamic(() => import("./SearchDialog"), { ssr: false });

/** Bouton de recherche du header + raccourci Cmd/Ctrl+K */
export default function HeaderSearch() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setOpen(true);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        aria-label="Rechercher un lieu (Ctrl+K)"
        title="Rechercher (Ctrl+K)"
        className="grid h-9 w-9 place-items-center rounded-full text-corail/85 transition-colors hover:text-or"
      >
        <Search className="h-[17px] w-[17px]" aria-hidden />
      </button>
      <SearchDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
